/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { ComponentItemFinderBusinessService } from '../../resources/component-item-finder-business.service';
import { ComponentItemFinderDialogComponent } from './component-item-finder-dialog.component';

export const componentItemFinderDialogRoute = createDialogRoute({
  component: ComponentItemFinderDialogComponent,
  init: ComponentItemFinderBusinessService,
});
